var Messages = /** @class */ (function () {
    function Messages() {
    }
    Messages.onValidated = "onValidated";
    Messages.documentClick = "documentClick";
    Messages.updateUser = "updateUser";
    return Messages;
}());
export { Messages };
